import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'

const WebViewParkingSpaceCount: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <Stepper
        id='mobile-parking-space-count'
        propertyName='noParkingSpaces'
        placeholder={t('wizard.screen.otherFacilities.webViewParkingSpace.count.placeholder')}
        label={t('wizard.screen.otherFacilities.webViewParkingSpace.count.label')}
        input={insertionData.noParkingSpaces?.toString()}
        type='tel'
        maxLength={4}
        max={999}
        step={1}
        errors={validationMessages?.noParkingSpaces ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default WebViewParkingSpaceCount
